module.exports = __webpack_public_path__ + "static/media/svmcontent.33517c57.PNG";